{
  "birthDate": "Lau aso fanau",
  "dateFormat": "dd/mm/yyyy",
  "familyName": "Lou igoa o le aiga",
  "helpMessage": "<p>Afai e le saʻo le numera i luga, pe e te le mautinoa le mea e fai, fa'amolemole vala'au mai i le <a><strong>{{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>).</p>",
  "sendCode": "Lafo le numera",
  "text": "<p>O lenei valaaulia mo se tusi o se gasegase o lo’o tausia e se tagata e iai le numera telefoni: <strong><PhonePlaceholder /></strong></p>\n<p>Afai o oe lea, fa'amolemole ulufale i le <strong>igoa o le aiga o le gasegase</strong> ma le <strong>aso fanau</strong> i lalo ma kiliki le faamau.</p>\n<p>Mo le saogalemu, o le a matou lafo atu se <strong>numera 4-numera fa'amaonia</strong> e fa'amaonia ai lou tulaga.</p>",
  "title": "Afio mai i le <strong>{{company}} Online Booking</strong>"
}
